import { useState } from "react";
import { siteConfig } from "../config/siteConfig";
import BookingModal from "./BookingModal";
import { ArrowUpRight } from "lucide-react";

export default function Offers() {
  const [open, setOpen] = useState(false);

  return (
    <section
      id="offers"
      data-testid="offers-section"
      className="section bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal">
          <p className="font-overline mb-4">Curated Experiences</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] mb-4">
            Offers & Packages
          </h2>
          <div className="gold-divider"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {siteConfig.offers.map((offer, i) => (
            <article
              key={offer.id}
              data-testid={`offer-card-${offer.id}`}
              className={`reveal group relative bg-[#F3EFE6] rounded-3xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-500 ${
                i === 0 ? "lg:col-span-2 lg:row-span-1" : ""
              }`}
            >
              <div className="relative overflow-hidden aspect-[16/10] rounded-3xl">
                <img
                  src={offer.image}
                  alt={offer.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-display text-2xl sm:text-3xl text-[#FAF9F6] mb-2">
                    {offer.title}
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <p className="text-[#2C2C2C] mb-5 leading-relaxed">
                  {offer.description}
                </p>
                <button
                  onClick={() => setOpen(true)}
                  className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#1A362D] hover:text-[#C5A059]"
                  data-testid={`offer-book-btn-${offer.id}`}
                >
                  Book This <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
      <BookingModal open={open} onOpenChange={setOpen} />
    </section>
  );
}
